module.exports = __webpack_public_path__ + "img/pethouse34.585bb0d9.jpg";